import { Divider } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Text from '@/components/switchback/Text/Text';

import GuestDetailItem from './GuestDetailItem';

interface IGuestDetailProps {
  adultsValue: number;
  childrenValue: number;
  infantsValue: number;
  onChangeAdults: (value: number) => void;
  onChangeChildren: (value: number) => void;
  onChangeInfants: (value: number) => void;
  isGuestOccupancyAvailable?: boolean;
}

const GuestDetail: React.FC<IGuestDetailProps> = ({
  adultsValue,
  childrenValue,
  infantsValue,
  onChangeAdults,
  onChangeChildren,
  onChangeInfants,
  isGuestOccupancyAvailable,
}) => {
  const intl = useIntl();
  const labels = {
    adults: {
      label: intl.formatMessage({
        description: 'Guests filter > Adult QuantitySelector title',
        defaultMessage: 'Adults',
        id: 'og/mwU',
      }),
      disclaimer: intl.formatMessage({
        description: 'Guests filter > Adult QuantitySelector disclaimer',
        defaultMessage: 'Ages 13 or above',
        id: 'Chp+P6',
      }),
    },
    children: {
      label: intl.formatMessage({
        description: 'Guests filter > Children QuantitySelector title',
        defaultMessage: 'Children',
        id: 'f7swIl',
      }),
      disclaimer: isGuestOccupancyAvailable
        ? intl.formatMessage({
            defaultMessage: 'Ages 3-12',
            id: 'cn4PHX',
          })
        : intl.formatMessage({
            description: 'Guests filter > Children QuantitySelector disclaimer',
            defaultMessage: 'Ages 12 or under',
            id: 'NouNP2',
          }),
    },
    infants: {
      label: intl.formatMessage({
        description: 'Guests filter > Infants QuantitySelector title',
        defaultMessage: 'Infants',
        id: '4sPQXv',
      }),
      disclaimer: intl.formatMessage({
        description: 'Guests filter > Infants QuantitySelector disclaimer',
        defaultMessage: 'Ages 2 or under',
        id: '0ipV9p',
      }),
    },
  };

  return (
    <div className="md:w-3/5">
      {!isGuestOccupancyAvailable && (
        <Text
          type="paragraph"
          className="mb-5 text-xs font-bold text-gray-500 uppercase semiHighlight">
          <FormattedMessage defaultMessage="guests" id="83vj7t" />
        </Text>
      )}
      <GuestDetailItem
        label={labels.adults.label}
        disclaimer={labels.adults.disclaimer}
        guestsCount={adultsValue}
        minQuantity={1}
        onChange={onChangeAdults}
      />
      <div className="hidden w-full h-4 md:block" />
      <Divider className="mt-3 mb-4 md:hidden" />
      <GuestDetailItem
        label={labels.children.label}
        disclaimer={labels.children.disclaimer}
        guestsCount={childrenValue}
        onChange={onChangeChildren}
      />

      {isGuestOccupancyAvailable && (
        <>
          <div className="hidden w-full h-4 md:block" />
          <Divider className="mt-3 mb-4 md:hidden" />
          <GuestDetailItem
            label={labels.infants.label}
            guestsCount={infantsValue}
            onChange={onChangeInfants}
            disclaimer={labels.infants.disclaimer}
          />
        </>
      )}
    </div>
  );
};

export default GuestDetail;
